import type { MessageDescriptor } from "@lingui/core";

/**
 * Lightweight replacement for `@lingui/core/macro`'s `msg` tagged template.
 * Produces the same `{ id, message }` shape without pulling in the Babel macro
 * runtime (which depends on Node.js builtins and crashes in browser bundles).
 *
 * Consumers (native/web) can pass these descriptors to their i18n runtime
 * (e.g. `i18n._(descriptor)` in Lingui, or a custom resolver in SolidJS).
 */
function msg(literals: TemplateStringsArray, ...expressions: unknown[]): MessageDescriptor {
  const message = String.raw(literals, ...expressions);
  return { id: message, message };
}

export const RECURRENCE_RULES = {
  NONE: null,
  DAILY: "FREQ=DAILY",
  WEEKLY: "FREQ=WEEKLY",
  MONTHLY: "FREQ=MONTHLY",
  YEARLY: "FREQ=YEARLY",
} as const;

export type RecurrenceRuleValue = (typeof RECURRENCE_RULES)[keyof typeof RECURRENCE_RULES];

export const RECURRENCE_OPTIONS = [
  { label: msg`Does not repeat`, value: RECURRENCE_RULES.NONE },
  { label: msg`Daily`, value: RECURRENCE_RULES.DAILY },
  { label: msg`Weekly`, value: RECURRENCE_RULES.WEEKLY },
  { label: msg`Monthly`, value: RECURRENCE_RULES.MONTHLY },
  { label: msg`Yearly`, value: RECURRENCE_RULES.YEARLY },
] as const;
